import { Hide, Icon } from '@chakra-ui/react';
import {
  MdDashboard,
  MdHome,
  MdLock,
  MdPictureAsPdf,
  MdSecurity,
  MdBuild
  // MdOutlineShoppingCart,
} from 'react-icons/md';

// Admin Imports
import DashboardsDefault from 'views/admin/dashboards/default';
import DashboardsRTLDefault from 'views/admin/dashboards/rtl';
import DashboardsCarInterface from 'views/admin/dashboards/carInterface';
import DashboardsSmartHome from 'views/admin/dashboards/smartHome';

// // NFT Imports
// import NFTMarketplace from 'views/admin/nfts/marketplace';
// import NFTPage from 'views/admin/nfts/page';
// import NFTCollection from 'views/admin/nfts/collection';
// import NFTProfile from 'views/admin/nfts/profile';

// Main Imports
import AccountBilling from 'views/admin/main/account/billing';
import AccountApplications from 'views/admin/main/account/application';
import AccountInvoice from 'views/admin/main/account/invoice';
import AccountSettings from 'views/admin/main/account/settings';
import AccountAllCourses from 'views/admin/main/account/courses';
import AccountCoursePage from 'views/admin/main/account/coursePage';

import UserNew from 'views/admin/main/users/newUser';
import UsersOverview from 'views/admin/main/users/overview';
import UsersReports from 'views/admin/main/users/reports';

import ProfileSettings from 'views/admin/main/profile/settings';
import ProfileOverview from 'views/admin/main/profile/overview';
import ProfileNewsfeed from 'views/admin/main/profile/newsfeed';

import ApplicationsKanban from 'views/admin/main/applications/kanban';
import ApplicationsDataTables from 'views/admin/main/applications/dataTables';
import ApplicationsCalendar from 'views/admin/main/applications/calendar';

import EcommerceNewProduct from 'views/admin/main/ecommerce/newProduct';
import EcommerceProductOverview from 'views/admin/main/ecommerce/overviewProduct';
// import EcommerceProductSettings from 'views/admin/main/ecommerce/settingsProduct';
import EcommerceProductPage from 'views/admin/main/ecommerce/pageProduct';
import EcommerceOrderList from 'views/admin/main/ecommerce/orderList';
import EcommerceOrderDetails from 'views/admin/main/ecommerce/orderDetails';
import EcommerceReferrals from 'views/admin/main/ecommerce/referrals';
/* import SalidasPage from 'views/admin/salidas'; */

import Test from "views/admin/main/ecommerce/dashboards/index";

import AddRecordForm from "views/admin/main/ecommerce/config/lineas/index";

// Others
import OthersNotifications from 'views/admin/main/others/notifications';
import OthersPricing from 'views/admin/main/others/pricing';
import OthersError from 'views/admin/main/others/404';
import Messages from 'views/admin/main/others/messages';

// Auth Imports
import ForgotPasswordCentered from 'views/auth/forgotPassword/ForgotPasswordCentered';
import ForgotPasswordDefault from 'views/auth/forgotPassword/ForgotPasswordDefault';
import ResetPassword from 'views/auth/forgotPassword/ResetPassword';
import LockCentered from 'views/auth/lock/LockCentered';
import LockDefault from 'views/auth/lock/LockDefault';
import SignInCentered from 'views/auth/signIn/SignInCentered';
import SignInDefault from 'views/auth/signIn/SignInDefault';
import SignUpCentered from 'views/auth/signUp/SignUpCentered';
import SignUpDefault from 'views/auth/signUp/SignUpDefault';
import VerificationCentered from 'views/auth/verification/VerificationCentered';
import VerificationDefault from 'views/auth/verification/VerificationDefault';
import { h } from '@fullcalendar/core/preact';
import SalidasPage from 'views/admin/SalidasPage';
import HistorialBajas from 'views/admin/HistorialBajas';
import FacturasPage from 'views/admin/FacturasPage';
import ImportarActivos from 'views/admin/ImportarActivos';
import ConfigBajas from 'views/admin/config/configBajas';
import ConfigUsuarios from 'views/admin/config/configUsuarios';
import ConfigAgentesSeguridad from 'views/admin/config/configAgentesSeguridad';
import ConfigDepreciacion from 'views/admin/config/configDepreciacion';

const routes = [
  // --- Dashboards ---
  /*  {
     name: 'Inicio',
     path: '/dashboards',
     icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
     collapse: true,
     items: [
       // Admin
       // PENDIENTE: Tablero Principal
       {
         name: 'Tablero de Activos',
         layout: '/admin',
         path: '/dashboards/default',
         protected: true,
         component: <DashboardsDefault />,
       },
       {
         name: 'Interfaz de Auto',
         layout: '/admin',
         path: '/dashboards/car-interface',
         component: <DashboardsCarInterface />,
         protected: true,
       },
       {
         name: 'Casa Inteligente',
         layout: '/admin',
         path: '/dashboards/smart-home',
         component: <DashboardsSmartHome />,
         protected: true,
       },
       // RTL
       {
         name: 'RTL',
         layout: '/rtl',
         path: '/dashboards/rtl',
         component: <DashboardsRTLDefault />,
         protected: true,
       },
     ],
   }, */
  // // --- NFTs ---
  // {
  //   name: 'NFTs',
  //   path: '/nfts',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Mercado',
  //       layout: '/admin',
  //       path: '/nfts/marketplace',
  //       component: <NFTMarketplace />,
  //       secondary: true,
  //       protected: true,
  //     },
  //     {
  //       name: 'Colección',
  //       layout: '/admin',
  //       path: '/nfts/collection',
  //       component: <NFTCollection />,
  //       secondary: true,
  //       protected: true,
  //     },
  //     {
  //       name: 'Página de NFT',
  //       layout: '/admin',
  //       path: '/nfts/page',
  //       component: <NFTPage />,
  //       secondary: true,
  //       protected: true,
  //     },
  //     {
  //       name: 'Perfil',
  //       layout: '/admin',
  //       path: '/nfts/profile',
  //       component: <NFTProfile />,
  //       secondary: true,
  //       protected: true,
  //     },
  //   ],
  // },
  // // --- Main pages ---

  /*       {
          // PENDIENTE : Ajustar - Personal Account
          name: 'Cuenta',
          path: '/main/account',
          collapse: true,
          items: [
            {
              // Facturación : Ajustar - Pendiente decidir uso
              name: 'Facturación',
              layout: '/admin',
              path: '/main/account/billing',
              exact: false,
              component: <AccountBilling />,
              protected: true,
            },
            {
              name: 'Gestión de Usuarios',
              layout: '/admin',
              path: '/main/account/application',
              exact: false,
              component: <AccountApplications />,
              protected: true,
            },
            {
              name: 'Factura',
              layout: '/admin',
              path: '/main/account/invoice',
              exact: false,
              component: <AccountInvoice />,
              protected: true,
            },
            {
              name: 'Configuración',
              layout: '/admin',
              path: '/main/account/settings',
              exact: false,
              component: <AccountSettings />,
              protected: true,
            },
            {
              name: 'Todos los Cursos',
              layout: '/admin',
              path: '/main/account/all-courses',
              exact: false,
              component: <AccountAllCourses />,
              protected: true,
            },
            {
              name: 'Página de Curso',
              layout: '/admin',
              path: '/main/account/course-page',
              exact: false,
              component: <AccountCoursePage />,
              protected: true,
            },
          ],
        }, */
  // --- Authentication ---
  {
    name: 'Autenticación',
    path: '/auth',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    collapse: true,
    hidden: true, // <-- también puedes ocultar subítems
    items: [
      // --- Sign In ---
      {
        name: 'Iniciar Sesión',
        path: '/sign-in',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/sign-in/default',
            component: <SignInDefault />,
            protected: false,
          },
          {
            name: 'Centrado',
            layout: '/auth',
            path: '/sign-in/centered',
            component: <SignInCentered />,
            protected: false,
          },
        ],
      },
      // --- Sign Up ---
      {
        name: 'Registrarse',
        path: '/sign-up',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/sign-up/default',
            component: <SignUpDefault />,
            protected: false,
          },
          {
            name: 'Centrado',
            layout: '/auth',
            path: '/sign-up/centered',
            component: <SignUpCentered />,
            protected: false,
          },
        ],
      },
      // --- Verification ---
      {
        name: 'Verificación',
        path: '/verification',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/verification/default',
            component: <VerificationDefault />,
            protected: false,
          },
          {
            name: 'Centrado',
            layout: '/auth',
            path: '/verification/centered',
            component: <VerificationCentered />,
            protected: false,
          },
        ],
      },
      // --- Lock ---
      {
        name: 'Bloquear',
        path: '/lock',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/lock/default',
            component: <LockDefault />,
            protected: false,
          },
          {
            name: 'Centrado',
            layout: '/auth',
            path: '/lock/centered',
            component: <LockCentered />,
            protected: false,
          },
        ],
      },
      // --- Forgot Password ---
      {
        name: 'Olvidar Contraseña',
        path: '/forgot-password',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/forgot-password/default',
            component: <ForgotPasswordDefault />,
            protected: false,
          },
          {
            name: 'Centrado',
            layout: '/auth',
            path: '/forgot-password/centered',
            component: <ForgotPasswordCentered />,
            protected: false,
          },
          {
            name: 'Restablecer Contraseña',
            layout: '/auth',
            path: '/reset-password/:token',
            component: <ResetPassword />,
            protected: false,
          },
        ],
      },
    ],
  },

  {
    // Activos = Se tiene una base
    name: 'Operación',
    path: '/config/settings',
    icon: <Icon as={MdBuild} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        // Nuevo Activo = Ya tiene diseño | funcionalidad
        // PENDIENTE: Implementar funcionalidad de adjuntar imagenes, y relacionar con el activo
        // Se tiene que ver dentro de detalles del activo | al igual que el codigo qr
        name: 'Dashboard',
        layout: '/admin',
        path: '/dashboards',
        exact: false,
        component: <Test />,
        protected: true,
        moduloClave: 'dashboard',
      },
      {
        // Nuevo Activo = Ya tiene diseño | funcionalidad
        // PENDIENTE: Implementar funcionalidad de adjuntar imagenes, y relacionar con el activo
        // Se tiene que ver dentro de detalles del activo | al igual que el codigo qr
        name: 'Crear activo',
        layout: '/admin',
        path: '/main/ecommerce/new-product',
        exact: false,
        hidden: true, // <-- también puedes ocultar subítems
        component: <EcommerceNewProduct />,
        protected: true,
      },
      {
        // Lista de Activos = Ya tiene diseño | "falta definir filtros y orden" | funcionalidad de detalle y edición preparada en los botones y vista 
        // Funcionalidades ya implementadas: Redirección, Detalle, Edidición, Creación
        name: 'Activos',
        layout: '/admin',
        path: '/main/ecommerce/order-list',
        exact: false,
        component: <EcommerceOrderList />,
        protected: true,
        moduloClave: 'activos',
      },
      {
        // Activos en Detalle y Editar = Ya quedo | Funcionalidad adicional resguardo despues | Funcionalidad principal actualizar datos)
        name: 'Detalles del Activo',
        layout: '/admin',
        path: '/main/ecommerce/page-example/:id',
        exact: false,
        component: <EcommerceProductPage />,
        protected: true,
        hidden: true, // <-- también puedes ocultar subítems
      },
      {
        // Detalles del Resguardo = Se tiene base traduccion - falta 
        name: 'Crear resguardo',
        layout: '/admin',
        path: '/main/ecommerce/order-details',
        exact: false,
        component: <EcommerceOrderDetails />,
        protected: true,
        hidden: true, // <-- también puedes ocultar subítems
      },
      {
        // Historial de Resguardos = Se tiene base traduccion - falta 
        name: 'Resguardos',
        layout: '/admin',
        path: '/main/ecommerce/referrals',
        exact: false,
        component: <EcommerceReferrals />,
        protected: true,
        moduloClave: 'resguardos',
      },
      {
        // Historial de Resguardos = Se tiene base traduccion - falta
        name: 'Importar activos',
        layout: '/admin',
        path: '/main/importar/activos',
        exact: false,
        component: <ImportarActivos />,
        protected: true,
        moduloClave: 'importar_activos',
      },
      {
        // Historial de Resguardos = Se tiene base traduccion - falta
        name: 'Salidas',
        layout: '/admin',
        path: '/main/ver/salidas',
        exact: false,
        component: <SalidasPage />,
        protected: true,
        moduloClave: 'salidas',
      },
      {
        name: 'Historial de Bajas',
        layout: '/admin',
        path: '/main/historial-bajas',
        exact: false,
        component: <HistorialBajas />,
        protected: true,
        moduloClave: 'historial_bajas',
      },
      {
        // Registro e importación (XML/CFDI) de facturas de proveedor
        name: 'Facturas',
        layout: '/admin',
        path: '/main/facturas',
        exact: false,
        component: <FacturasPage />,
        protected: true,
        moduloClave: 'facturas',
      },
      /*       {
              // Historial de Resguardos = Se tiene base traduccion - falta 
              name: 'Salidas',
              layout: '/admin',
              path: '/salidas',
              exact: false,
              component: <SalidasPage />,
              protected: true,
            }, */
      {
        // Activos en estado Pendiente = (PENDIENTE: Adaptar para Contralores | Aprovar-Rechazar bajas)
        name: 'Solicitudes de Baja de Activos',
        layout: '/admin',
        path: '/main/ecommerce/product-overview',
        exact: false,
        component: <EcommerceProductOverview />,
        protected: true,
        hidden: true, // <-- también puedes ocultar subítems
      },

    
    ],
  },
  {
    // Activos = Se tiene una base
    name: 'Reportes',
    path: '/config/settings',
    icon: <Icon as={MdPictureAsPdf} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        // Nuevo Activo = Ya tiene diseño | funcionalidad
        // PENDIENTE: Implementar funcionalidad de adjuntar imagenes, y relacionar con el activo
        // Se tiene que ver dentro de detalles del activo | al igual que el codigo qr
        name: 'Reporteador',
        layout: '/admin',
        path: '/reportes',
        exact: false,
        component: <Test />,
        protected: true,
        hidden: true,
      },
    ],
  },

{
  name: 'Configuración',
  path: '/config/settings',
  icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  collapse: true,
  items: [
    
        {
  name: 'Flujos de firmas',
  layout: '/admin',
  path: '/configuracion-salidas/tipos-baja',
  exact: false,
  component: <ConfigBajas />,
  protected: true,
  hidden: false,
  moduloClave: 'config_flujos_firmas',
},

        {
  name: 'Usuarios',
  layout: '/admin',
  path: '/configuracion/usuarios',
  exact: false,
  component: <ConfigUsuarios />,
  protected: true,
  hidden: false,
  adminOnly: true,
  moduloClave: 'config_usuarios',
},

        {
  name: 'Tabla de depreciación',
  layout: '/admin',
  path: '/configuracion/depreciacion',
  exact: false,
  component: <ConfigDepreciacion />,
  protected: true,
  hidden: false,
  moduloClave: 'config_depreciacion',
},

        {
  name: 'Agentes de seguridad',
  layout: '/admin',
  path: '/configuracion/agentes-seguridad',
  exact: false,
  component: <ConfigAgentesSeguridad />,
  protected: true,
  hidden: false,
  moduloClave: 'config_agentes_seguridad',
},

    // lo demás lo dejas igual
    {
      name: 'Lineas',
      layout: '/admin',
      path: '/lineas',
      exact: false,
      component: <AddRecordForm />,
      protected: true,
      hidden: true,
    },
    {
      name: 'Sublineas',
      layout: '/admin',
      path: '/sublineas',
      exact: false,
      component: <Test />,
      protected: true,
      hidden: true,
    },
    {
      name: 'Departamentos',
      layout: '/admin',
      path: '/departamentos',
      exact: false,
      component: <Test />,
      protected: true,
      hidden: true,
    },
    {
      name: 'Familias',
      layout: '/admin',
      path: '/familias',
      exact: false,
      component: <Test />,
      protected: true,
      hidden: true,
    },
    {
      name: 'Subfamilias',
      layout: '/admin',
      path: '/subfamilias',
      exact: false,
      component: <Test />,
      protected: true,
      hidden: true,
    },
    {
      name: 'Proveedores',
      layout: '/admin',
      path: '/proveedores',
      exact: false,
      component: <Test />,
      protected: true,
      hidden: true,
    },
    {
      name: 'Marcas',
      layout: '/admin',
      path: '/marcas',
      exact: false,
      component: <Test />,
      protected: true,
      hidden: true,
    },
    {
      name: 'Modelos',
      layout: '/admin',
      path: '/modelos',
      exact: false,
      component: <Test />,
      protected: true,
      hidden: true,
    },
  ],
}
,
  {
    // Activos = Se tiene una base
    name: 'Seguridad',
    path: '/security/settings',
    icon: <Icon as={MdSecurity} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        // Nuevo Activo = Ya tiene diseño | funcionalidad
        // PENDIENTE: Implementar funcionalidad de adjuntar imagenes, y relacionar con el activo
        // Se tiene que ver dentro de detalles del activo | al igual que el codigo qr
        name: 'Agregar Usuario',
        layout: '/admin',
        path: '/security/add-user',
        exact: false,
        component: <Test />,
        protected: true,
        hidden: true,
      },
    ],
  },
];

export default routes;
